export default __webpack_public_path__ + "static/media/381.5f697fb0.png";